var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-apex-charts',{ref:"refDonutChartPedido",attrs:{"type":"pie","height":"350","layout":"compact","options":_vm.chartOptions,"series":_vm.validSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }